import Vue from 'vue'

// 携带默认access_token的接口
const default_access_token_list = [
    // 公共个人资料
	'/home/user/public_profile',
    // 反馈bug
	'/home/user/report_bug',
    // 活动表查询
	'/home/event/search',
    // 图文详情
	'/home/tuwen/detail',
    // 私信发送
	'/home/message/send',
    // 方程式单个详情
	'/home/phamula/detail',
    // 物体对象详情
	'/home/object/detail',
    // 物体对象详情列表
	'/home/object/detail_list',
    // 查找订单
	'/home/order/lists'
];

// 无需携带access_token的接口
const need_not_access_token_list = [
	// 邮箱注册
	'/home/user/register',
	// 登录
	'/home/user/login',
	// 忘记密码，发送验证邮件
	'/home/user/forget_password',
	// 手机号注册短信验证码
	'/home/user/mobile_register_verifycode',
	// 手机号注册
	'/home/user/mobile_register',
	// 手机号找回密码-短信验证码
	'/home/user/mobile_password_verifycode',
	// 手机号找回密码-重置密码
	'/home/user/mobile_reset_password',
	// 发送短信验证码
	'/home/user/send_mobile_verifycode',
	// 校验短信验证码 (*可带可不带，详情查看API)
	'/home/user/check_mobile_verifycode',
	// 微信登录
	'/home/weixin/weixin_login',
	// 下单
	'/home/order/add'
];

export function configHandler() {
    // 本地数据存储的key(必须跟userInfo.js文件的存储的key一致)
    let APP_ID = 'eb4dd4e5488df8d37d0d0f3b013556e8';
    let BASE_URL = 'https://appinterface.xitohere.com';
    let SESSION_KEY = 'XITO_USER_IFON';
    let ACCESS_TOKEN = 'MDAwMDAwMDAwMISMpty1pd3avXaqsLJ4wM29hY6fhn6zaYB5hJ2JiaLNj4yz0LSpt92xnLOjsXWz37GEr6qIe8Vtf3ahqX2vodo';
    if (Vue.prototype.$config) {
        APP_ID =       Vue.prototype.$config['APP_ID']        || APP_ID;
        BASE_URL =     Vue.prototype.$config['API']           || BASE_URL;
        SESSION_KEY =  Vue.prototype.$config['SESSION_KEY']   || SESSION_KEY;
        ACCESS_TOKEN = Vue.prototype.$config['ACCESS_TOKEN']  || ACCESS_TOKEN;
    }
    return {
        APP_ID,
        BASE_URL: process.env.NODE_ENV === 'development' ? '/api/' : BASE_URL,
        SESSION_KEY,
        ACCESS_TOKEN
    };
    // const { APP_ID, BASE_URL, SESSION_KEY, ACCESS_TOKEN } = configHandler();
};

export function tokenHandler(api = '') {
	// 默认需要携带access_token
	let isNeed_token = true,
		access_token = '';
	if (api) {
		isNeed_token = !need_not_access_token_list.some(v => api.includes(v));
		if (isNeed_token) {
            const { SESSION_KEY, ACCESS_TOKEN } = configHandler();
			if (default_access_token_list.some(v => api.includes(v))) {
				access_token = ACCESS_TOKEN;
            } else {
                const session_data = JSON.parse(localStorage.getItem(SESSION_KEY) || '{}');
				if (session_data && session_data.user_info && session_data.user_info.access_token) {
					access_token = session_data.user_info.access_token;
				}
			}
		}
	}
	return {
		isNeed_token,
		access_token
	};
};

export function errorHandler(data = {}) {
	let title = '';
	if (data.status === 200) {
		if (data.data.status !== 'success') {
			// 错误描述
			if (data.data.status === 'error') {
				title = data.data.data.error_description;
			}
			// 错误的请求接口 不存在此API
			else if (data.data.status === 'redirect') {
				title = 'This API does not exist';
			}
			// 目前未知的返回情况 未知错误
			else {
				title = 'Unknown Error';
			}
		}
	} else {
		title = 'Unknown Error';
	}
	if (title === 'Please Login Again') {
        // store.commit('clearStateData');
		Vue.prototype.$EventBus.$emit('LOGIN_AGAIN', data.config.url);
	}
	if (title) {
		Vue.prototype.$message(title);
		const url = data.config.url;
		const param = data.status === 200 ? data.data : data;
		console.log(`%c 拦截失败的数据 %c ${title} %c ${url}`, 'color: red', 'color: green', 'color: blue', param);
	}
	return data.status === 200 ? data.data : data;
};

export const httpHandler = {
    get: function(url = '', data = {}) {
        const _this = this;
        const xhr = new XMLHttpRequest();
        const { _url, _data } = this.paramsHandler(url, data, 'get');
        return new Promise((resolve, reject) => {
            xhr.open('GET', _url, true);
            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        resolve(_this.parseJSON(xhr.responseText || ''));
                    } else {
                        reject();
                    }
                }
            }
            xhr.send(null);
        });
    },
    post: function(url = '', data = {}) {
        const _this = this;
        const xhr = new XMLHttpRequest();
        const { _url, _data } = this.paramsHandler(url, data, 'post');
        return new Promise((resolve, reject) => {
            xhr.open('POST', _url, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.onreadystatechange = function (result) {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        resolve(_this.parseJSON(xhr.responseText || ''));
                    } else {
                        reject();
                    }
                }
            }
            xhr.send(_data);
        });
    },
    jsonp: function(url = '', data = {}, key = 'callback', timeout = 10000) {
        const callback = 'jsonp_callback';
        data[key] = data[key] || callback;
        const { _url, _data } = this.paramsHandler(url, data, 'jsonp');
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            const timer = setTimeout(function(){
                document.head.removeChild(script);
                window[callback] = null;
                clearTimeout(timer);
                reject();
            }, timeout);
            window[callback] = function(json) {
                document.head.removeChild(script);
                window[callback] = null;
                resolve(json);
            }
            script.type = 'text/javascript';
            script.src = _url;
            document.head.appendChild(script);
        });
    },
    upload: function(url = '', data = {}, onProgress = null) {
        const _this = this;
        const xhr = new XMLHttpRequest();
        const { _url, _data } = this.paramsHandler(url, data, 'upload');
        return new Promise((resolve, reject) => {
            xhr.open('POST', _url, true);
            if (onProgress && typeof onProgress === 'function') {
                xhr.upload.onprogress = onProgress;
            }
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        resolve(_this.parseJSON(xhr.responseText || ''));
                    } else {
                        reject();
                    }
                }
            }
            xhr.send(_data);
        });
    },
    parseJSON: function(text = '') {
        try {
        	// return JSON.parse(text.replace(/\r|\n|\s/g, ''));
        	// return eval(text.replace(/\r|\n|\s/g, ''));
        	return JSON.parse(text);
        	// return eval(text);
        } catch(err) {
        	return text;
        }
    },
    paramsHandler: function(url = '', data = {}, type = 'get') {
    	let _url = url;
    	let _data = type === 'upload' ? new FormData() : '';
    	if (url && Object.keys(data).length) {
    		let param = Object.entries(data).map(([key, value]) => `${key}=${value}`).join('&');
    		if (type === 'get') {
    			_url += param ? `?${param}` : '';
    		}
    		if (type === 'post') {
    			_data = param;
    		}
    		if (type === 'jsonp') {
    			_url += param ? `?${param}` : '';
    		}
    		if (type === 'upload') {
    			Object.entries(data).forEach(([key, value]) => _data.append(key, value));
    		}
    	}
    	return {
    		_url,
    		_data
    	};
    }
};

export const dataHandler = {
    dataType: function(data, type = '') {
    	const _type = Object.prototype.toString.apply(data).slice(8, -1).toLowerCase();
    	return type ? type.indexOf(_type) > -1 : _type;
    },
    strToNum: function(data = '', keyArr = [], force = false) {
    	// force为true 则将数据不为数字时强制转换成0
    	if (data) {
    		let type = this.dataType(data);
    		let keyType = this.dataType(keyArr);
    		if (type === 'sring') {
    			if (isNaN(data) === false) {
    				data = Number(data);
    			} else {
    				if (force) {
    					data = 0;
    				}
    			}
    		}
    		else if (type === 'object') {
    			if (keyType === 'array' && keyArr.length) {
    				for (let p of keyArr) {
    					if (data[p] && isNaN(data[p]) === false) {
    						data[p] = Number(data[p]);
    					} else {
    						if (force) {
    							data[p] = 0;
    						}
    					}
    				}
    			}
    		}
    		else if (type === 'array') {
    			if (keyType === 'array' && keyArr.length) {
    				for (let p of data) {
    					for (let k of keyArr) {
    						if (p[k] && isNaN(p[k]) === false) {
    							p[k] = Number(p[k]);
    						} else {
    							if (force) {
    								p[k] = 0;
    							}
    						}
    					}
    				}
    			}
    		}
    	}
    	return data;
    },
    addBaseUrl: function(data = '', key = '') {
    	if (data) {
            const BASE_URL = Vue.prototype.$config['API'] || 'https://appinterface.xitohere.com';
    		const type = this.dataType(data);
    		if (type === 'string') {
    			data = data ? (BASE_URL + data) : '';
    		}
    		else if (type === 'object') {
    			if (key && data[key]) {
    				data[key] = BASE_URL + data[key];
    			}
    		}
    		else if (type === 'array') {
    			if (key) {
    				for (let p of data) {
    					p[key] && (p[key] = BASE_URL + p[key]);
    				}
    			} else {
    				for (let p of data) {
    					p && (p = BASE_URL + p);
    				}
    			}
    		}
    	}
    	return data;
    },
    arrayString: function(data = []) {
    	// [1, 2] => ["1","2"]
    	if (data.length) {
    		let str = '[';
    		for (let i = 0, length = data.length; i < length; i++) {
    			let itemType = this.dataType(data[i]);
    			if (itemType === 'object') {
    				str += '{';
    				for (let p in data[i]) {
    					str += `"${p}": "${data[i][p]}",`;
    				}
    				str = str.slice(0, str.length - 1) + '},';
    			} else {
    				str += `"${data[i]}",`;
    			}
    		}
    		str = str.slice(0, str.length - 1) + ']';
    		return str;
    	}
    	return '[]';
    },
    treeLayer: function(data = {}) {
    	if (data.su && data.su.length) {
    		return 1 + Math.max(...data.su.map(v => this.treeLayer(v)));
    	} else {
    		return 1;
    	}
    },
    nameHandler: function(name = '') {
    	if (name) {
    		let count = name.match(/\*/g);
    		if (count) {
    			if (count.length) {
    				if (count.length === 2) {
    					let nameArr = name.split('*');
    					//return nameArr[0] ? (nameArr[0] + nameArr[2]) : nameArr[2];
    					return nameArr.length === 3 ? (nameArr[0] + nameArr[2]) : nameArr[0];
    				} else {
    					return '';
    				}
    			}
    		}
    	}
    	return name;
    },
    eventDescription: function(text = '') {
    	// event的description解析
    	let url = '',
    		description = text;
    	if (text.indexOf('???') > -1) {
    		description = text.split('???')[0];
    		url = text.split('???')[1].replace(/amp;/g, '');
    		url = window.location.href.split('?')[0] + '?' + url;
    	}
    	return {
    		url,
    		description
    	};
    },
    getTuwenIdByTag: function(tag = '') {
    	if (tag) {
    		if (tag.indexOf('tuwen=') > -1 || tag.indexOf('tuwen_id=') > -1) {
    			let result = tag.match(/tuwen=[0-9]+|tuwen_id=[0-9]+/);
    			if (result && result[0]) {
    				return result[0].replace(/tuwen=|tuwen_id=/, '');
    			}
    		}
    	}
    	return '';
    },
    getPhamulaIdByUUID: function(uuid = '') {
    	if (uuid) {
    		const key = ['Phamula', 'phamula', 'Food', 'food'].find(_key => String(uuid).indexOf(_key) > -1);
    		return key ? String(uuid).replace(key + '-', '') : '';
    	}
    	return '';
    },
    objectType: function(uuid = '') {
    	// for (let p of OBJECT_TYPE) {
    	// 	if (p.test(uuid)) {
    	// 		return p.type;
    	// 	}
    	// }
    	return 0;
    },
    objHandler: function(obj = {}) {
    	// 单个对象数据处理
    	const numKeys = [
    		'points',
    		'is_private',
    		'wealth_points',
    		'following_count',
    		// 以上4个字段可能不存在
    		'sex',
    		'height',
    		'weight',
    		'is_owner',
    		'is_public',
    		'alarm_time',
    		'like_count',
    		'comment_count',
    		'activity_today',
    		'is_contributor',
    		'follower_count',
    		'activity_today1',
    		'activity_today2',
    		'contributor_count',
    		'is_virtual_locked',
    		'birthday_timestamp'
    	];
    	obj = this.strToNum(obj, numKeys);
    	obj.photo = this.addBaseUrl(obj.photo);
    	obj['newName'] = this.nameHandler(obj.name);
    	if (obj.gps_last) {
    		obj.gps_last = this.strToNum(obj.gps_last, ['time', 'gps_latitude', 'gps_longitude']);
    	}
    	if (obj.goal_last) {
    		obj.goal_last = this.strToNum(obj.goal_last, ['goal_1', 'goal_2', 'goal_3']);
    	}
    	if (obj.temperature_last) {
    		obj.temperature_last = this.strToNum(obj.temperature_last, ['temperature']);
    	}
    	if (obj.daka_list && obj.daka_list.length) {
    		obj.daka_list = this.strToNum(obj.daka_list, ['value', 'length', 'timestamp']);
    	}
    	if (obj.activity_list && obj.activity_list.length) {
    		obj.activity_list = this.strToNum(obj.activity_list, ['activity', 'activity1', 'activity2', 'time']);
    	}
    	if (obj.heartrate_list && obj.heartrate_list.length) {
    		obj.heartrate_list = this.strToNum(obj.heartrate_list, ['time', 'feel', 'heartrate']);
    	}
    	if (obj.temperature_list && obj.temperature_list.length) {
    		obj.temperature_list = this.strToNum(obj.temperature_list, ['time', 'temperature']);
    	}
    	if (obj.like_list && obj.like_list.length) {
    		obj.like_list = this.addBaseUrl(obj.like_list, 'user_photo');
    	}
    	if (obj.picture_list && obj.picture_list.length) {
    		obj.picture_list = this.addBaseUrl(obj.picture_list, 'picture');
    	}
    	if (obj.comment_list && obj.comment_list.length) {
    		obj.comment_list = this.addBaseUrl(obj.comment_list, 'user_photo');
    	}
    	if ('uuid' in obj) {
    		// obj['object_type'] = this.objectType(obj.uuid);
    		obj['phamula_id'] = this.getPhamulaIdByUUID(obj.uuid);
    	}
    	if ('tag' in obj) {
    		// obj['tagList'] = obj.tag.split(/\,|\，/).filter(Boolean);
    		obj['tuwen_id'] = this.getTuwenIdByTag(obj.tag);
    	}
    	return obj;
    },
    userHandler: function(user = {}) {
    	// 单个对象数据处理
    	const numKeys = [
    		'points',
    		'is_private',
    		'wealth_points',
    		'follower_count',
    		'following_count'
    	];
    	user = this.strToNum(user, numKeys);
    	user.photo = this.addBaseUrl(user.photo);
    	if (user.public_object_list && user.public_object_list.length) {
    		user.public_object_list = user.public_object_list.map(v => this.objHandler(v));
    	}
    	return user;
    },
    localToStamp: function(local = '') {
    	if (local) {
    		local = String(local).replace(/\-/g, '/');
    		return parseInt(new Date(local).getTime()) / 1000;
    	}
    	return 0;
    },
    htmlDecode: function(html = '') {
    	let str = '';
    	if (html.length) {
    		str = html.replace(/&amp;/g, "&");
    		str = str.replace(/&lt;/g, "<");
    		str = str.replace(/&gt;/g, ">");
    		str = str.replace(/&nbsp;/g, " ");
    		str = str.replace(/&#39;/g, "\'");
    		str = str.replace(/&quot;/g, "\"");
    		str = str.replace(/<br\/>/g, "\n");
    	}
    	return str;
    },
    trimHtml: function(str = '') {
    	str = str.replace(/(\n)/g, "");
    	str = str.replace(/(\t)/g, "");
    	str = str.replace(/(\r)/g, "");
    	str = str.replace(/<\/?[^>]*>/g, "");
    	str = str.replace(/\s*/g, "");
    	str = str.replace(/<[^>]*>/g,"");
    	return str;
    }
};